export function getProfileLocationLabel(profile) {
  const city = profile?.city?.trim();
  const country = profile?.country?.trim();

  if (city && country) return `${city}, ${country}`;
  if (city) return city;
  if (country) return country;

  if (profile?.locationSource === "gps") {
    return "Current location";
  }

  return "Add your location";
}
